import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
 getPatientRouteSheets () {
   return Api().get("/patient-route-sheets");
},
  updatePatientRouteSheet (params) {
    return Api().put("/patient-route-sheets",params);
  },
  addPatientRouteSheet (params) {
    return Api().post("/patient-route-sheets",params);
  },
  getPatientRouteSheet (params) {
    return Api().get("/patient-route-sheets/"+params);
  },
  deletePatientRouteSheet (params) {
    return Api().delete("/patient-route-sheets/"+params);
  },
  getPatientRouteSheetsByPatient(params){
    return Api().get("/patient-route-sheets-patient/"+params);
  },
  getOpenedPatientRouteSheets(params) {
    return Api().get("/opened-patient-route-sheets/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/PatientRouteSheetService.js